'use strict';

var KayleeBase = require('./KayleeBase');
var KayleeCompany = require('./KayleeCompany');
var KayleeEvent = require('./KayleeEvent');
var KayleeRoom = require('./KayleeRoom');
var KayleeSite = require('./KayleeSite');
var KayleeUser = require('./KayleeUser');
var KayleeUsers = require('./KayleeUsers');
var log = require('../log/Log').channel('KayleeUserRemove');
var sutl = require('../sutl/Sutl');

var KayleeUserRemove = {
    removeUser: removeUser,
    removeUserByEmail: removeUserByEmail,
};

function addUpdatesToRemoveUser(update, userId) {
    update['users/' + userId] = null;
    return KayleeEvent.addUpdatesForUserDeletedEvent(update, userId);
}

function isOnlyAdmin(userId, companyId) {
    return KayleeUsers.getUsers({ $nodeType: 'company', $id: companyId }).$loaded()
    .then(function(users) {
        for (var i = 0; i < users.length; i++) {
            var user = users[i];
            if (user.$id !== userId && user.$getRoleForCompany(companyId) === 'admin') {
                return false;
            }
        }

        return true;
    });
}

function removeUser(userId) {
    var user;
    var userStr;

    return KayleeUser.getUser(userId).$loaded()
    .then(function(loadedUser) {
        var promises = [];
        user = loadedUser;

        userStr = userId;
        if (user.firstName) userStr += ' ' + user.firstName;
        if (user.lastName) userStr += ' ' + user.lastName;
        userStr += ' <' + user.email + '>';

        // Make a copy of the roles since they will change as we start removing
        // roles and companies.

        var companyRoles = Object.assign({}, sutl.getNode(user, [ 'roles', 'companies' ], {}));

        for (var companyId in companyRoles) {
            if (!companyRoles.hasOwnProperty(companyId)) continue;
            promises.push(removeUserInCompany(user, companyId, companyRoles));
        }

        return Promise.all(promises);
    })
    .then(function() {
        return addUpdatesToRemoveUser({}, userId)
        .then(KayleeBase.update);
    })
    .then(function() {
        return KayleeBase.app.auth().deleteUser(userId);
    })
    .then(function() {
        log.debug('removed user ' + userStr);
        // return undefined
    });
}

function removeUserByEmail(email) {
    return KayleeBase.app.database().ref('users')
        .orderByChild('email').equalTo(email).once('value')
    .then(function(snap) {
        if (!snap.exists()) {
            return Promise.reject(new Error('User not found.'));
        }

        var users = snap.val();
        var userIds = Object.keys(users);

        if (userIds.length > 1) {
            return Promise.reject(new Error('Multiple users found.'));
        }

        return removeUser(userIds[0])
        .then(function() { return userIds[0]; });
    });
}

function removeUserInCompany(user, companyId, companyRoles) {
    return isOnlyAdmin(user.$id, companyId).then(function(isOnly) {
        if (isOnly) {
            return KayleeCompany.getCompany(companyId).$loaded()
            .then(function(company) {
                return company.$remove();
            });
        }

        var nodes = [];
        var role = sutl.getNode(companyRoles[companyId], [ 'role' ]);

        if (role !== null) {
            nodes.push(KayleeCompany.getCompany(companyId));
        }

        var siteRoles = sutl.getNode(companyRoles[companyId], [ 'sites' ], {});

        for (var siteId in siteRoles) {
            if (!siteRoles.hasOwnProperty(siteId)) continue;

            if (sutl.getNode(siteRoles[siteId], [ 'role' ]) !== null) {
                nodes.push(KayleeSite.getSite(siteId));
            }

            var roomRoles = sutl.getNode(siteRoles[siteId], [ 'rooms' ], {});

            for (var roomId in roomRoles) {
                if (!roomRoles.hasOwnProperty(roomId)) continue;

                if (sutl.getNode(roomRoles[roomId], [ 'role' ]) !== null) {
                    nodes.push(KayleeRoom.getRoom(roomId));
                }
            }
        }

        // Remove the roles serially rather than using Promise.all.

        return nodes.reduce(function(promiseChain, node) {
            return promiseChain.then(function() {
                return node.$loaded().then(function(){
                    return user.$setRole(node, null);
                });
            });
        }, Promise.resolve());

    });
}

module.exports = KayleeUserRemove;
